'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = require('../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _sizes = require('HubStyleTokens/sizes');

var _misc = require('HubStyleTokens/misc');

var _Styles = require('../../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H6 = (0, _styledComponents2.default)(_Heading2.default).withConfig({
  displayName: 'H6'
})(['', ';', ';text-transform:', ';'], _Styles.FONT_FAMILIES[_misc.HEADING_WEIGHT6], (0, _Styles.setFontSize)(_sizes.HEADING6), _misc.HEADING_CASE6);

H6.propTypes = _extends({}, _Heading2.default.propTypes);

H6.defaultProps = _extends({}, _Heading2.default.defaultProps, { tagName: 'h6' });

H6.displayName = 'H6';

exports.default = H6;
module.exports = exports['default'];